<template>
  <div class="plant">
    <form class="col-12" @submit.prevent="handleSubmit">
      <div class="row">
        <div class="col-6">
          <h2>Plant Detail</h2>
        </div>
      </div>
      <div v-if="plant">
        <div class="row">
          <div class="col-12">
            <h3>Plant Name</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="name">Name:</label>
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              id="name"
              ref="plant_name"
              name="name"
              placeholder="name"
              :value="getName()"
            />
          </div>
          <div
            v-if="submitted && errors.has('name')"
            class="col-12 invalid-feedback"
          >
            {{ errors.first("name") }}
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h3>Other Information</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-2">
            <label for="description">Notes:</label>
          </div>
          <div class="col-9">
            <textarea
              rows="4"
              class="form-control"
              id="description"
              ref="plant_description"
              name="description"
              placeholder="description"
              :value="getNotes()"
            />
          </div>
          <div
            v-if="submitted && errors.has('description')"
            class="col-12 invalid-feedback"
          >
            {{ errors.first("description") }}
          </div>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">
          New
        </button>
        <button v-if="plant" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>
      <div class="col-2" v-if="plant">
        <button
          id="delete"
          v-if="plant.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PlantDetail",
  props: {
    plant: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    submitted: false,
  }),
  methods: {
    ...mapActions("plants", ["apiSavePlant", "apiCreatePlant"]),
    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.save();
        }
      });
    },
    getName() {
      if (!this.plant) {
        return "";
      }
      return this.plant.name;
    },
    getAddressLine1() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.address1;
    },
    getAddressLine2() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.address2;
    },
    getAddressLine3() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.address3;
    },
    getAddressCity() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.city;
    },
    getAddressState() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.state;
    },
    getAddressPostcode() {
      if (!this.plant || !this.plant.address) {
        return "";
      }
      return this.plant.address.postcode;
    },
    getContactName() {
      if (!this.plant) {
        return "";
      }
      return this.plant.contact;
    },
    getNotes() {
      if (!this.plant) {
        return "";
      }
      return this.plant.description;
    },

    _delete() {
      if (this.plant && this.plant.id > 0) {
        this.plant.active = !this.plant.active;
        this.apiSavePlant(this.plant);
      }
    },
    save() {
      if (this.plant) {
        this.plant.name = this.$refs.plant_name.value;
        this.plant.description = this.$refs.plant_description.value;

        if (this.plant.id > 0) {
          this.apiSavePlant(this.plant);
        } else {
          this.apiCreatePlant(this.plant);
        }
        this.$emit("saved");
      }
    },
    clear() {},
  },
  components: {},
};
</script>
